// extracted by mini-css-extract-plugin
export default {"ScreenXSMax":"(max-width: 767px)","pricingContainer":"Gbba134","fullPrice":"G0d04c9","total":"G4fe343"};